<template>
    <div v-if="schedule.recurrence_deactivated">
        <slot name="no-recurrence">
            Das Ereignis kann keine Wiederholungen haben, da es von einer Serie entkoppelt wurde.
        </slot>
    </div>
    <div v-else class="schedule-form">
        <div id="recurrence-type-row" class="row">
            <div class="col-6">
                <form-select name="schedule[custom_repeat_type]" v-model="schedule.custom_repeat_type" :options="Schedule.repeatSelectOptions"
                    aria-label="Auswahl Wiederholungsverhalten"/>
            </div>
            <div class="col-6">
                <div v-if="'daily' === schedule.custom_repeat_type">
                    <div class="flex flex-vertical-middle">
                        <div>Jeden&nbsp;</div>
                        <div class="schedule-daily" :class="'schedule-daily-' + schedule.daily.type">
                            <form-select v-model="schedule.daily.type" name="schedule[daily][type]" :inherit-width="false" aria-label="Auswahl täglich oder Tagesintervall"
                                :options="[{value: 'interval', label: 'benutzerdefinierten Tag'},{value: 'weekday', label: 'Wochentag'}]">
                                <template #one>
                                    <template v-if="'interval' === schedule.daily.type">
                                        &nbsp;
                                    </template>
                                    <template v-else>
                                        Wochentag
                                    </template>
                                </template>
                            </form-select>
                            <form-input v-if="'interval' === schedule.daily.type" v-model="schedule.daily.interval" aria-label="Auswahl Tagesintervall"
                                name="schedule[daily][interval]" class="schedule-daily-input" size="none"/>
                        </div>
                        <div class="schedule-info" v-if="'interval' === schedule.daily.type">
                            Tag
                        </div>
                    </div>
                </div>
                <div v-else-if="'none' !== schedule.custom_repeat_type">
                    <div class="flex flex-vertical-middle flex-align-right">
                        {{'weekly' === schedule.custom_repeat_type ? 'Jede' : ('annually' === schedule.custom_repeat_type ? 'Jedes' : 'Jeden')}}&nbsp;
                        <form-input v-model="schedule[schedule.custom_repeat_type].interval" :name="'schedule[' + schedule.custom_repeat_type + '][interval]'"
                            style="width: 36px;"/>
                        <div class="schedule-info">
                            {{'weekly' === schedule.custom_repeat_type ? 'Woche' : ('monthly' === schedule.custom_repeat_type ? 'Monat' : 'Jahr')}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="'none' !== schedule.custom_repeat_type">
            <!--<editor-fold desc="weekly">-->
            <div id="recurrence-pattern-weekly" v-if="'weekly' === schedule.custom_repeat_type">
                <div id="recurrence-pattern-weekly-select" class="default-margin-top">
                    <form-select v-model="schedule.weekly.type" name="schedule[weekly][type]" aria-label="Auswahl wöchentlich oder an bestimmten Wochentagen"
                        :options="[{value: 'interval', label: 'Keine weiteren Einstellungen'},{value: 'weekday', label: 'An folgenden Wochentagen'}]"/>
                </div>

                <div v-if="'weekday' === schedule.weekly.type" class="flex flex-seize default-margin-top form-checkbox-button-row">
                    <div v-for="day in Schedule.dayValues" class="form-checkbox-button-wrapper">
                        <input :id="'schedule-weekday-' + day.number" type="checkbox" :value="day.number" v-model="schedule.weekly.weekday"
                            name="schedule[weekly][weekday][]" class="form-checkbox-button"/>

                        <label :for="'schedule-weekday-' + day.number">
                            <strong v-text="day.name"></strong>
                        </label>
                    </div>
                </div>
            </div>
            <!--</editor-fold>-->

            <!--<editor-fold desc="monthly">-->
            <div id="recurrence-pattern-monthly" v-if="'monthly' === schedule.custom_repeat_type">
                <div class="default-margin-top">
                    <form-select v-model="schedule.monthly.type" name="schedule[monthly][type]" aria-label="Auswahl Wochentage oder bestimmte Tage im Monat"
                        :options="[{value: 'interval', label: 'Keine weiteren Einstellungen'},{value: 'weekday', label: 'An folgenden Wochentagen'},{value: 'monthday', label: 'An folgenden Tagen im Monat'}]"/>
                </div>

                <template v-if="'weekday' === schedule.monthly.type">
                    <div class="default-margin-top">
                        <form-select v-model="schedule.monthly.weekno" name="schedule[monthly][weekno]" :options="Schedule.weekSelectOptions"
                            aria-label="Auswahl wievielter Wochentag im Monat"/>
                    </div>
                    <div class="flex half-margin-top">
                        <div v-for="day in Schedule.dayValues">
                            <input :id="'schedule-weekday-' + day.number" type="checkbox" :value="day.number" v-model="schedule.monthly.weekday"
                                name="schedule[monthly][weekday][]" class="form-checkbox-button"/>

                            <label :for="'schedule-weekday-' + day.number">
                                <strong v-text="day.name"></strong>
                            </label>
                        </div>
                    </div>
                </template>

                <template v-if="'monthday' === schedule.monthly.type">
                    <div v-for="(row, index) in Schedule.monthDays" class="flex" :class="0 === index ? 'default-margin-top' : 'half-margin-top'">
                        <div v-for="day in row">
                            <input :id="'schedule-monthday-' + day.number" type="checkbox" :value="day.number" v-model="schedule.monthly.monthday"
                                name="schedule[monthly][monthday][]" class="form-checkbox-button"/>

                            <label :for="'schedule-monthday-' + day.number">
                                <strong v-text="day.name"></strong>
                            </label>
                        </div>
                    </div>
                </template>
            </div>
            <!--</editor-fold>-->

            <!--<editor-fold desc="annually">-->
            <div id="recurrence-pattern-annually" v-if="'annually' === schedule.custom_repeat_type">
                <div class="default-margin-top">
                    <form-select v-model="schedule.annually.type" name="schedule[annually][type]" aria-label="Auswahl jährlich oder an bestimmten Wochentagen"
                        :options="[{value: 'interval', label: 'Keine weiteren Einstellungen'},{value: 'weekday', label: 'An folgenden Wochentagen'}]"/>
                </div>

                <div v-if="'weekday' === schedule.annually.type">
                    <div class="default-margin-top">
                        <form-select v-model="schedule.annually.weekno" name="schedule[annually][weekno]" :options="Schedule.weekSelectOptions"
                            aria-label="Auswahl wievielter Wochentag in bestimmtem Monat"/>
                    </div>

                    <div class="flex flex-space-between flex-vertical-middle half-margin-top">
                        <div v-for="day in Schedule.dayValues">
                            <input :id="'schedule-weekday-' + day.number" type="checkbox" :value="day.number" v-model="schedule.annually.weekday"
                                name="schedule[annually][weekday][]" class="form-checkbox-button"/>

                            <label :for="'schedule-weekday-' + day.number">
                                <strong v-text="day.name"></strong>
                            </label>
                        </div>
                        <div class="schedule-yearly-month-select">
                            im
                            <form-select v-model="schedule.annually.month" name="schedule[annually][month]" :options="Schedule.monthSelectOptions"
                                aria-label="Auswahl in welchem Monat"/>
                        </div>
                    </div>
                </div>
            </div>
            <!--</editor-fold>-->

            <div class="hrline">&nbsp;</div>

            <!--<editor-fold desc="end">-->
            <form-row id="recurrence-end-row" label="Ende der Wiederholungen" class="schedule-form-end no-margin-bottom">
                <div class="flex">
                    <form-select name="schedule[end][type]" v-model="schedule.end.type" aria-label="Auswahl Wiederholungsanzahl oder Enddatum"
                        :options="[{value: 'none', label: 'Kein Ende'},{value: 'count', label: 'Anzahl an Wiederholungen:'},{value: 'date', label: 'Wiederholen bis'}]"/>
                    <div v-if="'count' === schedule.end.type">
                        <form-input v-model="schedule.end.count" name="schedule[end][count]" maxlength="3" style="width: 30px;" aria-label="Anzahl Wiederholungen"/>
                    </div>
                    <div v-else-if="'date' === schedule.end.type">
                        <form-input-date v-model="schedule.end.date" name="schedule[end][date]" aria-label="Angabe Datum wiederholen bis"/>
                    </div>
                </div>
            </form-row>
            <!--</editor-fold>-->
        </template>
    </div>
</template>

<script setup lang="ts">
    import {useAbstractFormInput} from '@/composables/abstractFormInput';
    import {usePortuna} from '@/composables/portuna';
    import {FormRowKey} from '@/library/form';
    import Schedule from '../../library/form/schedule';
    import FormInput from './FormInput.vue';
    import FormInputDate from './FormInputDate.vue';
    import FormRow from './FormRow.vue';
    import FormSelect from './FormSelect.vue';
    import {inject, ref, toRefs, watch} from 'vue';

    const portuna = usePortuna();

    const emit = defineEmits<{
        (eventName: 'update:modelValue', moduleValue: ScheduleEditData): void;
    }>();

    const props = withDefaults(
        defineProps<{
            id?: string;
            required?: boolean;
            overwriteRequired?: boolean;
            errorName?: string;
            filterName?: string;
            modelValue: ScheduleEditData;
        }>(),
        {
            required: false,
            overwriteRequired: false,
            errorName: '',
            filterName: '',
            modelValue: () => ({} as ScheduleEditData),
        },
    );

    const {
              id,
              required,
              overwriteRequired,
              errorName,
              filterName,
              modelValue,
          } = toRefs(props);

    const parentFormRow = inject<Nullable<IFormRowContext>>(FormRowKey, null);

    const {
              expose,
          } = useAbstractFormInput(
        parentFormRow,
        id,
        required,
        overwriteRequired,
        errorName,
        filterName,
    );

    const schedule = ref(modelValue.value);

    watch(schedule, (value: ScheduleEditData) =>
    {
        emit('update:modelValue', value);
    });

    watch(modelValue, (newValue: ScheduleEditData) =>
    {
        schedule.value = newValue;
    });

    defineExpose(Object.assign({}, portuna, expose, {
        componentName: 'FormSchedule',
    }));
</script>